<div class="item">
  <div class="thumb">
    <img [ngClass]="{ 'grayscale': !achievement.completed }" [src]="getBadgeUrl(achievement)" [alt]="achievement.title">
  </div>
  <div class="info">
    <div class="title">{{achievement.title}}</div>
    <div class="text">{{achievement.description}}</div>
  </div>
</div>
